// extracted by mini-css-extract-plugin
module.exports = {"layout":"Layout_layout__rzROC","main":"Layout_main__1ekmI","content":"Layout_content__2ZQnQ"};